var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"keydown":function($event){if(!$event.shiftKey)return null;return _vm.handlePrefillFormKey.apply(null, arguments)}}},[_c('vue-progress-bar',{staticClass:"hide-in-percy"}),_c('HeaderNav'),_c('keep-alive',{attrs:{"include":"Game"}},[(_vm.httpError)?_c('HttpError'):_c('router-view',{staticClass:"app-content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }